import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import styles from "./DealerSearchResults.module.scss";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { publish } from "../../../../common/PubSub";
import AuthenticationClient from "../../../../shared/clients/AuthenticationClient";

class DealerSearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onSubmit = (props, dealer) => {
    this.updateCurrentDealer(props, dealer);
  };

  updateCurrentDealer = (props, dealer) => {
    AuthenticationClient.getReadOnlyPermissions(
      props.user,
      props.selectedMarket
    ).then((result) => {
      dealer.userId = props.user.userId;
      dealer.permissions = result;
      dealer.userType = "dealer";
      dealer.brand = dealer.commonId.split("|")[3];
      dealer.market = dealer.commonId.split("|")[0];
      dealer.dealerId = dealer.completeDealerId;
      dealer.roles = props.userDetails.roles;
      dealer.fromNSCDealerSearch = true;
      dealer.poDealerSearch = props.poDealerSearch;
      props.updateUserDetails(dealer);
      publish("nscDealerSearch", true);
    });
  };

  render() {
    return (
      <div>
        <Table>
          <TableHead className={styles.tableHead}>
            <TableRow>
              <TableCell>
                <div>{this.props.t("fieldView.dealerName")}</div>
              </TableCell>
              <TableCell>
                <div>{this.props.t("fieldView.dealerType")}</div>
              </TableCell>
              <TableCell>
                <div>{this.props.t("fieldView.dealerAddress")}</div>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {this.props.dealers.map((dealer, index) => (
              <TableRow id={"row" + index} key={index}>
                <TableCell>{dealer.name}</TableCell>
                <TableCell className={styles.dealerType}>
                  {this.props.selectedMarket + " PV"}
                </TableCell>
                <TableCell>
                  <div className={styles.dealerAddress}>
                    {dealer.address && (
                      <>
                        <span>{dealer.address.street},</span>
                        <span>
                          {dealer.address.city}, {dealer.address.country},{" "}
                          {dealer.address.postalCode}
                        </span>
                      </>
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <Link
                    data-testid="viewDealerLink"
                    to="/dashboard"
                    className={styles.detailsLink}
                    onClick={() => this.onSubmit(this.props, dealer)}
                  >
                    {this.props.t("fieldView.viewDealer")}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default withTranslation("emp")(DealerSearchResults);
